import { createEffect, createEvent, sample } from 'effector';
import { aiServiceCommonApiClient } from '@nx-frontend/shared/next-api/proxy/clients';

interface AiAgentCategoriesAddAgentToCategoryEventPayload {
  agentId: string;
  orgId: string;
  categories: string[];
}

export const aiAgentCategoriesAddAgentToCategoryEvent = createEvent<AiAgentCategoriesAddAgentToCategoryEventPayload>();

const aiAgentCategoriesAddAgentToCategoryFx = createEffect(
  async (payload: AiAgentCategoriesAddAgentToCategoryEventPayload): Promise<void> => {
    const { agentId, orgId, categories } = payload;

    await aiServiceCommonApiClient.AgentApi.apiUpdateAgentCategories(
      {
        org: orgId,
        id: agentId,
        data: { categories },
      },
      {
        withCredentials: true,
      }
    );
  }
);

sample({
  source: aiAgentCategoriesAddAgentToCategoryEvent,
  target: aiAgentCategoriesAddAgentToCategoryFx,
});
